import React, { useEffect, useState } from 'react';
import { getdata, deletedata } from "../../util/global";
import { locationitem, locationitemdef } from './Datatype';
import LocationTable from './LocationTable';
import LocationForm from './LocationForm';

const Location = () => {
  const [locations, setlocations] = useState<locationitem[]>([]);
  const [showmodal, setshowmodal] = useState("");
  const [formdata, setformdata] = useState<locationitem>(locationitemdef);

  const fetchdata = async () => {
    try {
      const res = await getdata({ filter: { datatype: "locationdata" } });
      setlocations(res ? [...res].reverse() : []);
    } catch (err) {
      console.error(err);
    }
  };

  const openadd = () => {
    setformdata({ ...locationitemdef });
    setshowmodal("showlocationform");
  };

  const openedit = (item: locationitem) => {
    setformdata({ ...item });
    setshowmodal("showlocationform");
  };

  const deletelocation = (item: locationitem) => {
    if (!confirm(`delete location ${item.code}?`)) return;
    deletedata({ filter: { datatype: "locationdata", _id: item._id } }, () => {
      fetchdata();
    });
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3>Locations</h3>
        <button className="btn-blue" onClick={openadd}>+ Add Location</button>
      </div>

      <LocationTable
        locations={locations}
        openedit={openedit}
        deletelocation={deletelocation}
      />
      <LocationForm
        showmodal={showmodal}
        setshowmodal={setshowmodal}
        formdata={formdata}
        setformdata={setformdata}
        fetchdata={fetchdata}
      />
    </div>
  );
};

export default Location;
